export default "__VITE_ASSET__BVP1KF3c__"